export default __webpack_public_path__ + "static/media/WB_Arcade3.48be163d.gif";